<template>
    <div class="m-menu-drawer cy-pc-hide" :class="{'active': active}">
        <div class="header-cover">
            <LanguagPart :showFlag="true" className="in-m"></LanguagPart>
            <span class="close" @click="close"> <cy-icon type="close"></cy-icon></span>
        </div>
        <div class="menu-list">
            <div v-for="(item, index) in sideMenu" :key="item.title + 'parent'">
                <div v-if="item.subMenu">
                    <div class="menu-title" @click="toggleMenu(index)">{{ item.title }}</div>
                    <div :class="{
                        'show-sub': item.open,
                    }" class="sub-cover">
                        <div class="sub-title" v-for="subItem in item.subMenu" :key="subItem.title + 'sub'">
                            <a :href="subItem.url">{{ subItem.title }} </a>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="menu-title">
                        <a :href="item.url">{{ item.title }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-cover">
            <div v-if="outerLinkArr &&outerLinkArr.length" class="outlink-cover">
                <div v-for="outItem in outerLinkArr" :key="outItem.text" class="outlink-item">
                    <a :href="outItem.url" rel="nofollow"><img :src="outItem.svg" :alt="outItem.text"></a>
                </div>
            </div>
            <a class="order-btn cy-button" :href="rootHref==='/' ? orderLink : rootHref + orderLink">{{ orderText }}</a>
            <!-- <cy-button class="order-btn">{{ orderText }}</cy-button> -->
        </div>
    </div>
</template>

<script>
import LanguagPart from './language.vue';

export default {
    name: 'MenuDrawer',
    components: {
        LanguagPart,
    },
    props: {
        active: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        rootHref() {
            return this.locale === 'en' ? '/' : `/${this.locale}`;
        }
    },
    data() {
        const { sideMenu, outerLinkArr, orderLink, locale = 'en' } = window.globalNavConfig || {};
        return {
            sideMenu,
            orderText: window.globalNavConfig.PRORDER,
            outerLinkArr,
            orderLink,
            locale
        }
    },
    methods: {
        toggleMenu(index) {
            this.sideMenu[index].open = !this.sideMenu[index].open;
        },
        close() {
            this.$emit('close');
        }
    },
}
</script>

<style lang="scss" scoped>

// html[data-issafari*='true'] .m-menu-drawer {
//     height: calc(var(--vh) * 100);
// }
.m-menu-drawer {
    font-family: ABCDiatypeMedium-Medium, ABCDiatypeMedium;
    font-weight: 500;
    position: fixed;
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 500px;
    height: 100vh;
    height: 100vh;
    max-height: 100vh;
    height: calc(var(--vh) * 100);
    background: #fff;
    z-index: 1000001; // 大于 cookies > 客服
    overflow-y: auto;
    transform: translateX(-100%);
    // opacity: 0;
    transition: transform .3s cubic-bezier(.4,0,.25,1),opacity .3s cubic-bezier(.4,0,.25,1),-webkit-transform .3s cubic-bezier(.4,0,.25,1);

    // @media screen and (-webkit-min-device-pixel-ratio: 0) {
    //     height: calc(var(--vh) * 100);
    // }
    &.active {
        transform: translateX(0);
        // opacity: 1;
    }

    .header-cover {
        // position: absolute;
        // left: 0;
        // top: 0;
        width: 100%;
        height: 100px;
        padding: 25px 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .close {
            cursor: pointer;
            padding: 0 20px;
        }
    }

    .menu-list {
        flex: 1;
        overflow-y: scroll;
        padding: 0 20px;

        &::-webkit-scrollbar {
            display: none;
        }
        .menu-title {
            font-size: 20px;
            // font-weight: 600;
            color: #282828;
            padding: 20px 0;
            cursor: pointer;

            a {
                text-decoration: none;
                color: #282828;
            }
        }

        .sub-cover {
            height: 0;
            overflow: hidden;
            cursor: pointer;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            &.show-sub {
                height: auto;
            }

            .sub-title {
                font-size: 16px;
                padding: 15px;
            }
        }
    }

    .footer-cover {
        // position: absolute;
        // left: 0;
        // bottom: 0;
        width: 100%;
        height: 100px;
        padding: 20px 15px 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: #FAFAF6;

        .outlink-cover {
            display: flex;
            gap: 20px;
            align-items: center;
            .outlink-item {
               img {
                    width: 20px;
                    height: 20px;
               }
            }
        }
        .order-btn {
            width: fit-content;
        }
    }
}
</style>